import Link from 'next/link';
import React from 'react';

import { type Scalars } from '../../__generated-gql-types__/globalTypes';
import { getCoachUrl } from '../../utils/coach';

import { type OtherCategoriesTextCoachFragment } from './__generated-gql-types__/OtherCategoriesText.generated';

interface OtherCategoriesTextProps {
  className?: string;
  coach: OtherCategoriesTextCoachFragment;
  excludeCategoryUrn: Scalars['CategoryUrn']['output'];
}

const OtherCategoriesText: React.FC<OtherCategoriesTextProps> = ({
  className = '',
  coach: {
    slug: coachSlug,
    categoryInformationList,
    user: { firstName },
  },
  excludeCategoryUrn,
}) => {
  const highLevelProfileLink = getCoachUrl({ coachSlug, categorySlug: null });

  const filteredCategoryInformationList = categoryInformationList?.filter(
    (c) => c.category.id !== excludeCategoryUrn,
  );

  return (
    <p className={`text-base font-normal text-leland-gray-light ${className}`}>
      {filteredCategoryInformationList &&
      filteredCategoryInformationList.length > 1 ? (
        <>
          {firstName} also coaches for{' '}
          {filteredCategoryInformationList.map((categoryInfo, i) => (
            <span key={categoryInfo.category.id}>
              {filteredCategoryInformationList.length > 1 &&
              i === filteredCategoryInformationList.length - 1
                ? 'and '
                : ''}
              <Link
                href={getCoachUrl({
                  coachSlug,
                  categorySlug: categoryInfo.category.slug,
                })}
                className="link text-leland-gray-extra-light underline"
              >
                {categoryInfo.category.name}
              </Link>
              {i === filteredCategoryInformationList.length - 1
                ? ''
                : filteredCategoryInformationList.length > 2
                  ? ', '
                  : ' '}
            </span>
          ))}
          .{' '}
          <Link
            href={highLevelProfileLink}
            className="link text-leland-primary underline"
          >
            View all
          </Link>
          .
        </>
      ) : (
        <Link
          href={highLevelProfileLink}
          className="link text-leland-primary underline"
        >
          View all of {firstName}&rsquo;s categories
        </Link>
      )}
    </p>
  );
};

export default OtherCategoriesText;
